<div class="content content-fixed" *ngIf="isFeatureEnabled$ | async">
  <div class="container">
    <div class="mb-3 text-xl normal-case">Age Verification</div>
    <form [formGroup]="ageVerificationForm" class="flex flex-wrap w-full p-4 bg-white rounded-md shadow-lg">
      <div class="w-full mb-4">
        <label for="dob" class="block mb-1 text-xs font-normal">Date of Birth:</label>
        <input id="dob" formControlName="dob" type="date"
          class="w-full text-sm border border-gray-300 rounded-md px-2 py-1 focus:border-black focus:outline-none hover:border-black"
          [ngClass]="{
            'border-red-500': ageVerificationForm.get('dob')?.invalid && ageVerificationForm.get('dob')?.touched
          }" />
      </div>

      <div class="flex justify-between w-full mb-4">
        <button type="button" class="px-3 py-1 text-sm border rounded-md btn btn-default" (click)="resetForm()">
          Clear Form
        </button>
        <button type="button" class="px-3 py-1 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700"
          (click)="verifyAge()">
          Verify Age
        </button>
      </div>

      <div *ngIf="isOver21 !== null" class="w-full mb-4">
        <div class="flex items-center justify-center p-4 rounded-md"
          [ngClass]="isOver21 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
          <span class="text-lg font-bold">
            {{ isOver21 ? 'Age Verified: Over 21' : 'Age Verification Failed: Under 21' }}
          </span>
        </div>
      </div>

      <div *ngIf="isOver21" class="w-full">
        <button type="button" class="px-3 py-1 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700"
          (click)="showSSNVerification()">
          Verify SSN
        </button>
      </div>

      <div *ngIf="showSSNForm" class="w-full mt-4">
        <label for="ssn" class="block mb-1 text-xs font-normal">Social Security Number:</label>
        <input id="ssn" formControlName="ssn" type="text" placeholder="XXX-XX-XXXX"
          class="w-full text-sm border border-gray-300 rounded-md px-2 py-1 focus:border-black focus:outline-none hover:border-black"
          [ngClass]="{
            'border-red-500': ageVerificationForm.get('ssn')?.invalid && ageVerificationForm.get('ssn')?.touched
          }" />
        
        <div class="flex justify-end mt-4">
          <button type="button" class="px-3 py-1 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700"
            (click)="verifySSN()">
            Verify SSN
          </button>
        </div>

        <div *ngIf="ssnVerified" class="mt-4">
          <div class="flex items-center justify-center p-4 bg-green-100 text-green-800 rounded-md">
            <span class="text-lg font-bold">SSN Verified Successfully</span>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div *ngIf="!(isFeatureEnabled$ | async)" class="content content-fixed">
  <div class="container">
    <div class="flex items-center justify-center p-8 bg-red-100 text-red-800 rounded-md">
      <span class="text-lg font-bold">Age Verification feature is not enabled for your organization.</span>
    </div>
  </div>
</div> 